export enum Network {
  TRC20 = 'trc20',
}
